// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jb-3";
export var downloadButton = "_jb-4";
export var fileContainer = "_jb-9 _jb-7";
export var fileContainerBase = "_jb-7";
export var fileContainerFixedHeight = "_jb-8 _jb-7";
export var fileInfo = "_jb-5";
export var fileInfoWidthRestricted = "_jb-6";
export var fileType = "_jb-1";
export var fileTypeName = "_jb-2";
export var image = "_jb-0";
export var link = "_jb-b";
export var overflowEllipsis = "_jb-a";